/* eslint-disable react/jsx-key */
import * as React from "react";
import { createContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";


export const ThemeContext = createContext(null);

const HeaderPorto = (props) => {

    const {onThemeChange, theme} = props

    const toggleTheme = () => {
        const switchBtn = document.getElementById("switchBtn");
        if (switchBtn?.checked) {
            onThemeChange("dark");
            localStorage.setItem('Dark_Mode', JSON.stringify("dark"))
        } else {
            onThemeChange("light");
            localStorage.setItem('Dark_Mode', JSON.stringify("light"))
        }
    };

    useEffect(() => {
        var datax = window.localStorage.getItem("chechkbox");

        if (datax !== null) {
            const trueCheck = document.getElementById("switchBtn");
            trueCheck.checked = datax;
        }
    }, []);

    useEffect(() => {
        const trueCheckx = document.getElementById("switchBtn");

        trueCheckx?.addEventListener("click", () => {
            if (trueCheckx.checked) {
                localStorage.setItem("chechkbox", trueCheckx?.value);
            } else {
                localStorage.removeItem("chechkbox");
            }
        })
    }, []);

    useEffect(() => {
        document.addEventListener("scroll", () => {
            const header = document.querySelector("header");
            if (window.scrollY > 100) {
                header?.classList.add("active");
            } else {
                header?.classList.remove("active");
            }
        });
    }, []);

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            <header id="headx" className="navbar2">
                <div className="w-full xl:w-[90%] m-auto p-2">
                    <div className="relative">
                        <div className="flex justify-around lg:justify-between items-center relative">
                            <div className="flex justify-center items-center w-auto cursor-pointer">
                                <Link to="/">
                                    <img
                                        src="https://res.cloudinary.com/datadriven/image/upload/v1623300735/Wordpress%20Alcott/Alcott_Logo_01_White_1.png"
                                        alt=""
                                        className="w-[200px] lg:w-[222px] h-[auto]"
                                    />
                                </Link>
                            </div>
                            <div className="flex items-center lg:px-4">
                                <div className="flex justify-center items-center relative mt-0">
                                    <input
                                        id="switchBtn"
                                        type="checkbox"
                                        value="1"
                                        className="hidden"
                                        onChange={toggleTheme}
                                    />
                                    <label
                                        htmlFor="switchBtn"
                                        className="flex justify-center items-center cursor-pointer"
                                    >
                                        <div className="w-6 h-2 bg-LintasanDM rounded-full flex items-center">
                                            <div className="w-4 h-4 bg-DotDM rounded-full toggle-circle"></div>
                                        </div>
                                    </label>
                                    <span
                                        id="spanMode"
                                        className="mHeader ml-2 text-[18px] lg:text-[20px] labelTogg"
                                    >
                                        {theme === "light" ? "Light" : "Dark"}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </ThemeContext.Provider>
    );
};

export default HeaderPorto;
